import React from 'react';
import DemoBanner from '@/components/DemoBanner';
import './UploadDocuments.css';

const UploadDocuments: React.FC = () => {
  return (
    <div className="upload-documents-page">
      <div className="upload-documents-container">
        <DemoBanner />
        {/* Page content will be added here in the future */}
      </div>
    </div>
  );
};

export default UploadDocuments;

